import type { CSSProperties } from 'react';

import classNames from 'classnames';

import Serializer from './components/Serializer';

import { processPostTheme } from './utils/processPostTheme';
import { processPostTOC } from './utils/processPostTOC';

import { postContentElement } from './PostContent.css';
import type { PostContentElementProps } from './PostContent.types';
import { PostContentProvider } from './provider';
import { postThemeToCSSVariables, webThemeToCSSVariables } from './utils';

export function PostContentElement(props: PostContentElementProps) {
  const {
    id,
    isLive,
    element,
    attributes,
    postTheme,
    webTheme,
    translations,
    homePath,
    loginPath,
    subscribePath,
    upgradePath,
    showSubscriberBreak,
    showPaywallBreak,
    ChildDecoratorComponent,
    isIndexingDisabled,
    rewriteImageSrc,
    utmParams,
    isSubscriberAuthenticated,
    children,
  } = props;

  const { maxWidth } = element.attrs || {};
  const serializerContent = processPostTOC(element.attrs.data || {});

  return (
    <PostContentProvider utmParams={utmParams} postTheme={postTheme}>
      <div
        {...attributes}
        className={classNames(postContentElement, !isLive && 'pointer-events-none', 'post-content-node')}
        id={id}
        style={
          {
            '--max-width': maxWidth,
            width: '100%',
            ...postThemeToCSSVariables(processPostTheme(postTheme)),
            ...(webTheme ? { ...webThemeToCSSVariables(webTheme) } : {}),
            '--post-content-inline-link-color': element.attrs.linkColor,
          } as CSSProperties
        }
      >
        <Serializer
          isLive={isLive}
          translations={translations}
          content={serializerContent}
          homePath={homePath}
          loginPath={loginPath}
          subscribePath={subscribePath}
          showSubscriberBreak={showSubscriberBreak}
          showPaywallBreak={showPaywallBreak}
          ChildDecoratorComponent={ChildDecoratorComponent}
          upgradePath={upgradePath}
          isIndexingDisabled={isIndexingDisabled}
          rewriteImageSrc={rewriteImageSrc}
          isSubscriberAuthenticated={isSubscriberAuthenticated}
        />
        {children}
      </div>
    </PostContentProvider>
  );
}
